
<div class="constants">
    <div class="name"  routerLink="tax-planning/customer/dashboard" routerLinkActive="selectedNav">      
        <span class="nav-icons">
            <img src="../../../images/sidebar-svg/dashboard_icon.svg" alt="dashboard-icon" />
        </span>
        <span class="rightTooltiptext">DASHBOARD</span>
    </div>

    <div class="name" routerLink="tax-planning/customer-tax-planning" routerLinkActive="selectedNav">
        <span class="nav-icons">
            <img src="../../../images/sidebar-svg/fluent_library_icon.svg" alt="tax-strategies" />
        </span>
        <span class="rightTooltiptext">TAX PLANNING & ROI</span>
    </div>
    <div class="name"  [ngClass]="isTODO? 'active' : ''" routerLink="toDo/all" routerLinkActive="selectedNav">
        <span class="nav-icons">
            <img src="../../../images/sidebar-svg/toDo_Icon.svg" class="to-do" />
        </span>     
      <span class="rightTooltiptext">TO DO'S</span>
      <span class="float-right wall-badge" *ngIf="todoCount && todoCount > 0">{{todoCount}}</span>
    </div>

    <div class="name"  [routerLink]="['/tax-planning/questionnaire-response']"
    [queryParams]="{ customerQuestionnaires: true }" routerLinkActive="selectedNav">
        <span class="nav-icons">
            <img src="../../../images/sidebar-svg/Questionnaire_icon.svg" alt="questionnaire" />
        </span>
        <span class="rightTooltiptext">QUESTIONNAIRE</span>
    </div>
</div>

<div #qount class="dropdown-pane bottom export-dropdown side-export-dropdown customer-side-export" id="side-export-dropdown-id" data-dropdown data-hover="false" data-hover-pane="false" foundation>
    <div class="title">
        <span class="name-badge" [style.background-color]="user.colorCode || ''">
            <span style="cursor: default;font-weight: bold;">{{getUserBadgeName(user)}}</span>
        </span>
        <span style="text-transform: capitalize;margin-left: 5px;font-size: 14px;color: #707070">{{user.first_name}} {{user.last_name}}</span>
    </div>
</div>
<div id="sound"></div>
<div class="delegate-info" *ngIf="delegatedUser">
    <span>You are logged in as</span><span>{{delegatedUser.first_name}}</span><span>{{delegatedUser.last_name}}</span><span>({{delegatedUser.id}})</span>
</div>
